/**
 * Paleta del módulo de Agua: blanco + azul, con su variante para modo oscuro.
 *
 * El resto del sistema usa naranja de marca; acá el azul es intencional
 * (representa el agua) y se mantiene consistente en las tres pantallas.
 */

export const AZUL        = "#0284c7";  // sky-600 — color de acción principal
export const AZUL_CLARO  = "#0ea5e9";  // sky-500 — hover / gráficas
export const AZUL_HONDO  = "#0369a1";  // sky-700 — texto sobre fondo claro
export const VERDE       = "#10b981";
export const AMBAR       = "#f59e0b";
export const ROJO        = "#ef4444";

export function aguaTheme(isLight) {
  return {
    isLight,
    azul: AZUL,
    heroBg: isLight
      ? "linear-gradient(135deg,#f0f9ff 0%,#e0f2fe 55%,#f8fafc 100%)"
      : "linear-gradient(135deg,#082f49 0%,#0f172a 60%,#0c4a6e 100%)",
    heroBorder: isLight ? "rgba(2,132,199,0.28)" : "rgba(14,165,233,0.22)",
    heroShadow: isLight
      ? "0 4px 24px rgba(2,132,199,0.13),0 1px 3px rgba(0,0,0,0.05)"
      : "0 0 0 1px rgba(255,255,255,0.03),0 16px 48px rgba(0,0,0,.5)",
    heroText: isLight ? "#0f172a" : "#ffffff",
    heroSub:  isLight ? "rgba(15,23,42,0.55)" : "rgba(255,255,255,0.5)",
    cardShadow: isLight ? "0 2px 8px rgba(0,0,0,.05)" : "0 2px 12px rgba(0,0,0,.2)",
    chipBg:     isLight ? "rgba(2,132,199,0.09)" : "rgba(14,165,233,0.14)",
    chipBorder: isLight ? "rgba(2,132,199,0.25)" : "rgba(14,165,233,0.28)",
    chipText:   isLight ? AZUL_HONDO : "#7dd3fc",
    grid:       isLight ? "rgba(15,23,42,0.08)" : "rgba(255,255,255,0.08)",
  };
}

/** Formatea metros cúbicos con separador de miles y 2 decimales. */
export function m3(valor, sufijo = " m³") {
  if (valor == null || valor === "") return "-";
  const n = Number(valor);
  if (Number.isNaN(n)) return "-";
  return n.toLocaleString("es-CR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }) + sufijo;
}

/** '2026-08-18' -> '18/08/2026' sin pasar por Date (evita corrimiento de zona). */
export function fechaCorta(iso) {
  if (!iso) return "-";
  const [y, m, d] = String(iso).slice(0, 10).split("-");
  return `${d}/${m}/${y}`;
}

/** Fecha de hoy en formato YYYY-MM-DD, en hora local (no UTC). */
export function hoyISO() {
  const d = new Date();
  const mes = String(d.getMonth() + 1).padStart(2, "0");
  const dia = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${mes}-${dia}`;
}
